"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zodKnownFieldDefaultValidation = void 0;
/**
 * Default suggested validation constants for known fields
 *
 * @example
 * z.object({
 *     email: z.string().min(1).max(zodKnownFieldDefaultValidation.stringMax),
 * })
 * @example
 */
exports.zodKnownFieldDefaultValidation = {
    stringMax: 255,
    arrayMax: 100,
    recordRefineCondition: (obj) => Object.keys(obj).length <= 100,
    recordRefineErrorMessage: 'too many record keys',
};
